const badgeTheme = {
  baseStyle: {
    borderRadius: "999px",
    fontWeight: "700",
    letterSpacing: "0.02em",
    px: 2.5,
    py: 1,
  },
  variants: {
    subtle: (props) => ({
      bg: `${props.colorScheme}.50`,
      color: `${props.colorScheme}.700`,
      borderWidth: "1px",
      borderColor: `${props.colorScheme}.100`,
    }),
  },
  defaultProps: {
    variant: "subtle",
    colorScheme: "neutral",
  },
};

export default badgeTheme;
